module.exports = __webpack_public_path__ + "img/CS-Lite-Vol_Overview.1b5967d4.jpg";